import { SchemaTypes } from '@allesauto/graphql';
import translate from '@allesauto/i18n';
import { EmailNew20, ProgressBarRound20 } from '@carbon/icons-react';
import { IntlShape } from 'react-intl';

export const sharedOverlaySuccessTranslations = (
  intl: IntlShape,
  dealerName: string,
  isWhiteLabelInstance?: boolean | undefined
) => {
  return {
    SUBMISSION_THANK_YOU: translate(
      intl,
      isWhiteLabelInstance
        ? 'ui.FORMS.OVERLAY_SUCCESS.SUBMISSION_THANK_YOU_WL'
        : 'ui.FORMS.OVERLAY_SUCCESS.SUBMISSION_THANK_YOU'
    ),
    DEALER_CONFIRMATION_MSG: translate(
      intl,
      isWhiteLabelInstance
        ? 'ui.FORMS.OVERLAY_SUCCESS.DEALER_CONFIRMATION_MSG_WL'
        : 'ui.FORMS.OVERLAY_SUCCESS.DEALER_CONFIRMATION_MSG',
      {
        dealerName: dealerName,
      }
    ),
    FAVORITE_MSG: translate(intl, 'ui.FORMS.OVERLAY_SUCCESS.FAVORITE_MSG'),
    TO_FAVORITE_LIST: translate(
      intl,
      'ui.FORMS.OVERLAY_SUCCESS.TO_FAVORITE_LIST'
    ),
    NEXT_STEPS_TEXT: translate(
      intl,
      'ui.FORMS.OVERLAY_SUCCESS.NEXT_STEPS_TEXT'
    ),
    BUTTON_TEXT: translate(intl, 'ui.FORMS.OVERLAY_SUCCESS.BUTTON_TEXT'),
    CREDIT_ASSESSMENT_BACK_TO_PDP: translate(
      intl,
      'ui.PAYMENT_OPTIONS.CREDIT_ASSESSMENT_BACK_TO_PDP'
    ),
  };
};

export const sharedOverlayDetailsSteps = (
  intl: IntlShape,
  dealerName: string,
  contactPerson: SchemaTypes.ContactPerson,
  isWhiteLabelInstance?: boolean | undefined
) => {
  return [
    <>
      <ProgressBarRound20 />
      <span className="ml-20px">
        {isWhiteLabelInstance
          ? translate(
              intl,
              'ui.FORMS.OVERLAY_SUCCESS.PROCESSING_REQUEST_MSG_WL',
              {
                contactPersonName:
                  (contactPerson &&
                    contactPerson.lastName &&
                    contactPerson.lastName.length > 0) ||
                  (contactPerson.firstName &&
                    contactPerson.firstName.length > 0)
                    ? contactPerson.lastName + ' ' + contactPerson.firstName
                    : dealerName,
              }
            )
          : translate(intl, 'ui.FORMS.OVERLAY_SUCCESS.PROCESSING_REQUEST_MSG', {
              contactPersonName:
                (contactPerson &&
                  contactPerson.lastName &&
                  contactPerson.lastName.length > 0) ||
                (contactPerson.firstName && contactPerson.firstName.length > 0)
                  ? contactPerson.lastName + ' ' + contactPerson.firstName
                  : dealerName,
            })}
      </span>
    </>,
    <>
      <EmailNew20 />
      <span className="ml-20px">
        {isWhiteLabelInstance
          ? translate(intl, 'ui.FORMS.OVERLAY_SUCCESS.REQUEST_COPY_MSG_WL')
          : translate(intl, 'ui.FORMS.OVERLAY_SUCCESS.REQUEST_COPY_MSG')}
      </span>
    </>,
  ];
};
